import type { RemoteFile } from "@pdfking/pdfengine"
import { IsString, JSONDecode } from "@pdfking/tfunc"

export default (
  filelist: Record<string, RemoteFile> | string | undefined
): Record<string, RemoteFile> =>
  IsString(filelist) ? JSONDecode(filelist) : filelist || {}
